import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import endpoints from './endpoints';
import { get, MICROSERVICES } from 'api';
import { REQUEST_LIFE_CICLE, IMyKnownError } from 'interfaces/requests';
import { AppDispatch } from 'store';
import { AxiosResponse } from 'axios';
import { openAlertToUserLogoutAction } from 'modules/user';
import { parseParametersResponse } from './helpers';
import { Parameters, ParametersResponse } from './interfaces';

interface ParametersState {
  list: Parameters;
  loading: REQUEST_LIFE_CICLE;
}

const initialState = {
  list: { serviceTypes: [], serviceCategories: [] },
  loading: 'idle',
} as ParametersState;

export const fetchParametersAction = createAsyncThunk<
  Parameters,
  undefined,
  {
    dispatch: AppDispatch;
    rejectValue: IMyKnownError;
  }
>('parameters/fetch', async (payload, { dispatch, rejectWithValue }) => {
  try {
    const response: AxiosResponse<ParametersResponse> = await get(
      MICROSERVICES.STRATEGIES,
      {
        url: endpoints.parameters(),
      },
    );
    return parseParametersResponse(response.data);
  } catch (err) {
    dispatch(openAlertToUserLogoutAction());
    return rejectWithValue((await err.json()) as IMyKnownError);
  }
});

const parametersSlice = createSlice({
  name: 'parameters',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchParametersAction.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = REQUEST_LIFE_CICLE.SUCCEEDED;
    });
    builder.addCase(fetchParametersAction.rejected, (state) => {
      state.loading = REQUEST_LIFE_CICLE.FAILED;
    });
  },
});
const { reducer } = parametersSlice;
export default reducer;
